/* assets/lumen-main.js
   LUMEN — 메인 페이지 공통 JS
   1) Fixed CTA 버튼: IntersectionObserver로 섹션별 텍스트/링크 변경
   2) 헤더 blend-mode 제어 (Dawn 테마 호환)
*/

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // ── Fixed 버튼 ──────────────────────────────────
    var btn = document.querySelector('.lumen-main-var-btn__link');
    var infoEls = document.querySelectorAll('.lumen-fixed-btn-info');

    if (!btn || infoEls.length === 0) return;

    function updateBtn(el) {
      if (!el) return;
      var title = el.dataset.title;
      var link = el.dataset.link;
      if (title) btn.textContent = title;
      if (link && link !== '#none') {
        btn.setAttribute('href', link);
      } else {
        btn.setAttribute('href', '#');
      }
    }

    // 초기값: 첫 번째 섹션
    updateBtn(infoEls[0]);

    var lastScrollY = window.scrollY;

    var observer = new IntersectionObserver(
      function (entries) {
        var isDown = window.scrollY > lastScrollY;

        entries.forEach(function (entry) {
          if (isDown && entry.isIntersecting && entry.intersectionRatio >= 0.1) {
            updateBtn(entry.target);
          } else if (!isDown && entry.isIntersecting) {
            var rect = entry.boundingClientRect;
            if (rect.top <= 0 && rect.bottom >= 0) {
              updateBtn(entry.target);
            }
          }
        });

        lastScrollY = window.scrollY;
      },
      {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: [0, 0.1],
      }
    );

    infoEls.forEach(function (el) {
      observer.observe(el);
    });

    // ── 헤더 blend-mode: Dawn 테마 클래스 감지 ──────
    // Dawn은 header에 js 클래스를 붙이지 않으므로
    // details[open] 감지로 메뉴 오픈 상태 추적
    var header = document.querySelector('#shopify-section-header, header-drawer, details[id^="Details-menu"]');
    if (!header) return;

    var menuObserver = new MutationObserver(function () {
      var isOpen = !!document.querySelector('details[open]');
      document.body.classList.toggle('menu-open', isOpen);
    });

    document.querySelectorAll('details').forEach(function (d) {
      menuObserver.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  });
})();
